var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0767 38.0906C41.4611 38.6969 40.5418 39 39.3187 39H19.6813C18.4662 39 17.5489 38.6989 16.9294 38.0966C16.3098 37.4943 16 36.5949 16 35.3983V21.6017C16 20.4051 16.3098 19.5057 16.9294 18.9034C17.5489 18.3011 18.4662 18 19.6813 18H39.3187C40.5418 18 41.4611 18.3031 42.0767 18.9094C42.6922 19.5157 43 20.4131 43 21.6017V35.3983C43 36.5869 42.6922 37.4843 42.0767 38.0906ZM18.0751 22.0093H40.923L40.924 21.7573C40.924 21.1909 40.7772 20.7641 40.4835 20.4769C40.1898 20.1897 39.7734 20.0462 39.2342 20.0462H19.7658C19.2266 20.0462 18.8102 20.1897 18.5165 20.4769C18.2228 20.7641 18.076 21.1909 18.076 21.7573L18.0751 22.0093Z",
    fill: "#081720"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2333 36.953H19.7649C19.2257 36.953 18.8093 36.8094 18.5156 36.5222C18.2219 36.235 18.0751 35.8083 18.0751 35.2419L18.0742 23.707H40.9221L40.9231 35.2419C40.9231 35.8083 40.7763 36.235 40.4826 36.5222C40.1889 36.8094 39.7724 36.953 39.2333 36.953Z",
    fill: "#EB69FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7176 3.1624C36.4163 1.76903 32.7964 1 29 1C13.536 1 1 13.7599 1 29.5C1 45.2401 13.536 58 29 58C44.464 58 57 45.2401 57 29.5C57 25.6358 56.2445 21.9513 54.8755 18.591C53.4564 15.1076 51.3781 11.9726 48.799 9.34746",
    stroke: "#081720",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4526 46.1076C42.4004 46.1076 45.6597 42.8195 45.6597 38.8368C45.6597 34.8467 42.3931 31.5586 38.4453 31.5586C34.4976 31.5586 31.2383 34.8467 31.2383 38.8368C31.2383 42.8195 34.4976 46.1076 38.4526 46.1076Z",
    fill: "#081720"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4526 44.548C35.3105 44.548 32.791 41.9988 32.791 38.8363C32.791 35.6664 35.3032 33.1172 38.4453 33.1172C41.5874 33.1172 44.1069 35.6664 44.1143 38.8363C44.1216 41.9988 41.5874 44.548 38.4526 44.548Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4521 40.3627C39.9902 40.3627 41.0083 41.4636 41.0083 41.9291C41.0083 42.0252 40.9424 42.0695 40.8691 42.0104C40.3931 41.6188 39.5581 41.2346 38.4521 41.2346C37.3462 41.2346 36.4893 41.6336 36.0278 42.0104C35.9546 42.0621 35.8887 42.0252 35.8887 41.9291C35.8887 41.4636 36.9067 40.3627 38.4521 40.3627Z",
    fill: "#081720"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5107 38.2019C36.9062 38.2019 37.2432 37.8546 37.2432 37.3595C37.2432 36.8644 36.9062 36.5098 36.5107 36.5098C36.1152 36.5098 35.793 36.8644 35.793 37.3595C35.793 37.8546 36.1152 38.2019 36.5107 38.2019Z",
    fill: "#081720"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4014 38.2019C40.7969 38.2019 41.1338 37.8546 41.1338 37.3595C41.1338 36.8644 40.7969 36.5098 40.4014 36.5098C40.0132 36.5098 39.6836 36.8644 39.6836 37.3595C39.6836 37.8546 40.0132 38.2019 40.4014 38.2019Z",
    fill: "#081720"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.7a1334280e4dc621807ffbbc444b18d3.svg";
export { ForwardRef as ReactComponent };